var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',[_vm._v(_vm._s(_vm.text.emailsIntro))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('code',[_vm._v("\n        "+_vm._s(_vm.text.emailsIntroCode)+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5569d9bd","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EmailsSettings/settings/emailsIntro.vue
// module id = 437
// module chunks = 0